import Context from '../entities/Context';
import Language from '../entities/Language';
import Section from '../entities/Section';
import Media from '../entities/Media/Media';
import CardTranslation from '../entities/Card/CardTranslation';
import MediaTranslation from '../entities/Media/MediaTranslation';
import QuestionTranslation from '../entities/Question/QuestionTranslation';
import Card from '../entities/Card/Card';
import Question from '../entities/Question/Question';
import Product from '../entities/Product';
import User from '../entities/User';

class Parser {

    getMyCardsToCards(response){
        var cards = [];
        response.data.forEach((element)=>{
            cards.push(this.elementToCard(element));
        });
        return cards;
    }

    getMyContextsToContexts(response){
        var contexts = [];
        response.data.forEach((element) => {
            contexts.push(this.elementToContext(element));
       });
       return contexts;
    }

    getMySectionsToSections(response){
        var sections = [];
        response.data.forEach((element) => {            
            sections.push(this.elementToSection(element));
       });
       return sections;
    }

    getMyProductsToProducts(response){
        var products = [];        
        response.data.forEach((element) => {           
            products.push(this.elementToProduct(element));
        });
        return products;
    }

    getCardToCard(response){
        return this.elementToCard(response.data);
    }

    getCardsToCards(response){
        var cards = [];
        response.data.forEach((element)=>{
            cards.push(this.elementToCard(element)); 
        });
        return cards;
    }  

    getMyOrdersToOrders(response){
        var orders = [];
        response.data.forEach((element)=>{
            orders.push(this.elementToOrder(element));
        });
        return orders;
    }

    getMyOrderToOrder(response){       
        return this.elementToOrder(response.data);
    }

    elementToOrder(element){
        var order = {};
        order.id = element.id;
        order.number = element.numero_pedido;
        order.date = element.data_pedido;        
        order.status = element.status;
        order.products = [];
        element.produtos.forEach((product)=>{
            order.products.push(this.elementToProduct(product));
        });
        return order;
    }

    getMyInfoToUser(response){
        return new User(response.id, response.nome, response.usuario, response.email, null);
    }
    
    validateToken(response){
        return response.data.valido;
    }

    renewToken(response){
        return response.data.token;
    }

    elementToContext(element){        
        return new Context(element.id, element.nome, this.elementToLanguage(element));
    }

    elementToSection(element){
        return new Section(element.id, element.nome, this.elementToContext(element.contexto));
    }

    elementToLanguage(element){
        return new Language(element.id, element.nome, element.codigo);
    }

    elementToProduct(element){
        var cards = [];
        element.fichas.forEach(card=>{
            cards.push(this.elementToCard(card));
        })
        return new Product(element.id, element.titulo, element.descricao, element.preco, cards, this.elementToMedia(element.midia));
    }

    elementToCard(element){
        var id = element.id
        var section = this.elementToSection(element.secao);
        var medias = [];
        element.midias.forEach(media=>{
            medias.push(this.elementToMedia(media));
        });
        var translations = this.elementToCardTranslations(element.traducoes);
        var questions = [];
        element.perguntas.forEach(question=>{
            questions.push(this.elementToQuestion(question));
        })
        return new Card(id, section, translations, medias, questions); 
    }

    elementToMedia(element){
        if(element===undefined){
            return null;
        }
        return new Media(element.id, element.nome, element.tipo, this.elementToMediaTranslations(element.traducoes));
    }

    elementToQuestion(element){
        return new Question(element.id, this.elementToMedia(element.midia), element.ordem, this.elementToQuestionTranslations(element.traducoes));
    }

    elementToCardTranslations(element){
        if(element===undefined){
            return null;
        }
        var translations = [];
        element.forEach((translation)=>{
            translations.push(new CardTranslation(translation.titulo, translation.introducao, translation.ajuda, this.elementToLanguage(translation.lingua)));
        });
        return translations;        
    }

    elementToMediaTranslations(element){
        if(element===undefined){
            return null;
        }
        var translations = [];
        element.forEach((translation)=>{
            translations.push(new MediaTranslation(translation.legenda, this.elementToLanguage(translation)));
        });        
        return translations;
    }

    elementToQuestionTranslations(element){
        if(element===undefined){
            return null;
        }
        var translations = [];
        element.forEach((translation)=>{
            translations.push(new QuestionTranslation(translation.texto, this.elementToLanguage(translation.lingua)));
        });
        return translations;
    }        
}

export default new Parser();